import type { Theme } from './types'

export const corporateTheme: Theme = {
  name: 'corporate',
  colors: {
    // Corporate professional green
    primary: '#0d7377',
    secondary: '#14a085',
    
    // Corporate backgrounds
    background: '#f5f7fa',
    surface: '#ffffff',
    
    // Professional text colors
    text: '#2d3748',
    textSecondary: '#718096',
    
    // Defined border
    border: '#cbd5e0',
    
    // Corporate status colors
    success: '#38a169',
    warning: '#d69e2e',
    error: '#e53e3e',
    
    // Corporate order status colors
    statusDraft: '#a0aec0',      // Light gray
    statusSubmitted: '#3182ce',   // Professional blue
    statusConfirmed: '#38a169',   // Success green
    statusBilled: '#d69e2e',      // Attention orange
    statusCompleted: '#0d7377',   // Primary green
  },
  spacing: {
    xs: '0.25rem',
    sm: '0.5rem',
    md: '1rem',
    lg: '1.5rem',
    xl: '2.5rem',    // Slightly more conservative than minimal
  },
  typography: {
    fontFamily: '"Segoe UI", "Roboto", "Helvetica Neue", Arial, sans-serif',
    fontSize: {
      sm: '0.875rem',   // 14px
      md: '1rem',       // 16px
      lg: '1.125rem',   // 18px
      xl: '1.375rem',   // 22px - slightly larger headers
    },
    fontWeight: {
      normal: 400,
      medium: 500,
      bold: 600,
    },
  },
  borderRadius: {
    sm: '0.375rem',  // 6px - professional rounded
    md: '0.5rem',    // 8px - well-rounded
    lg: '0.75rem',   // 12px - more rounded for cards
  },
  shadows: {
    sm: '0 1px 3px rgba(0, 0, 0, 0.1)',      // Defined shadows
    md: '0 4px 6px rgba(0, 0, 0, 0.1)',      // Card shadows
    lg: '0 10px 25px rgba(0, 0, 0, 0.15)',   // Modal shadows
  },
} 